/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable object-curly-newline */
/* eslint-disable max-len */

import React, { useState } from 'react';
import PropTypes from 'prop-types';

function FAQSection({ faqDataList, toggleShow, showAll, totalFaqList, borderRemove, pageName, isTitle = false }) {
  const [expandedIndex, setExpandedIndex] = useState(null);
  // console.log(faqDataList);

  const toggleAnswer = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <div className={`w-full mx-auto rounded-lg ${pageName !== 'courseDetail' ? 'lg:mb-[36px] mb-7 lg:px-0 px-5' : 'lg:mb-7 mb-[26px] lg:px-0 px-4'} lg:pb-[30]`}>
      {
        !isTitle && (
          <>
            <h2 className={`${pageName !== 'courseDetail' ? 'lg:text-lg md-text-xl text-xl text-[#0f172a] mb-3' : 'text-black lg:text-lg text-base mb-4'} font-semibold lg:mb-6  hidden lg:block`}>Frequently Asked Questions (FAQ&apos;s)</h2>
            <h2 className={`${pageName !== 'courseDetail' ? 'text-xl text-[#0f172a] mb-3' : 'text-black text-base mb-4'} font-semibold text-[#0f172a] xl:hidden block`}>FAQ&apos;s</h2>
          </>
        )
      }
      <div className="space-y-4">
        {faqDataList && faqDataList.length > 0
          && faqDataList.map((faq, index) => (
            <div key={faq.id} className={`${borderRemove || 'border rounded-md'}  overflow-hidden border-[#b8e5ff] bg-white`}>
              <button
                type="button"
                className={`${pageName !== 'courseDetail' ? 'px-4 py-4' : 'lg:px-4 lg:pt-4 lg:pb-2 px-0 py-2 '} w-full flex justify-between items-center text-left`}
                onClick={() => toggleAnswer(index)}
              >
                <span className={`${pageName !== 'courseDetail' ? 'text-sm md:text-sm lg:text-base xl:text-base 2xl:text-base  text-[#334155]' : 'text-sm text-black'} font-medium  w-[95%]`}>{faq.question}</span>
                <svg
                  className={`h-5 w-5 text-gray-500 transition-transform ${expandedIndex === index ? 'rotate-180' : ''
                  }`}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>
              {expandedIndex === index && (
                <div className={`${pageName !== 'courseDetail' ? 'text-[#334155] font-light text-sm md:text-sm lg:text-base xl:text-base 2xl:text-base' : 'text-sm text-black font-light'} lg:ps-4 pb-4 lg:pe-8 bg-white ps-2 pe-2`} dangerouslySetInnerHTML={{ __html: faq.answer }} />
              )}
            </div>
          ))}
        {/* //     ) : (
      //       <PageDataNotFound noMsg="No Data Available" />
      // )} */}
      </div>
      {/* --------show more button-------- */}
      {totalFaqList?.length > 2 && (
        <div className="lg:hidden block mt-7 text-center">
          <button
            type="button"
            onClick={toggleShow}
            className="bg-white border border-[#AAAAAAA1] text-[#909090] lg:px-40 py-[9px] lg:w-auto w-full justify-center text-base font-medium rounded-md flex items-center  mx-auto"
          >
            {showAll ? 'Show Less' : 'Show More'}
            {' '}
            <svg width="28" height="28" viewBox="0 0 18 8" className="ps-2" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 0.800049L9 7.20005L17 0.800048" stroke="#909090" />
            </svg>
          </button>
        </div>
      )}
      {/* --------end button-------- */}
    </div>
  );
}

FAQSection.propTypes = {
  faqDataList: PropTypes.any.isRequired,
  toggleShow: PropTypes.any,
  showAll: PropTypes.any,
  totalFaqList: PropTypes.any,
  isTitle: PropTypes.bool,
  borderRemove: PropTypes.any,
  pageName: PropTypes.any,
};
export default FAQSection;
